/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_More_SkillsInputs */

const en_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add more skill keywords — aim for 8-15 for better ATS matching`)
};

const de_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge mehr Skill-Keywords hinzu — strebe 8-15 an für besseres ATS-Matching`)
};

const fr_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez plus de mots-clés de compétences — visez 8-15 pour un meilleur matching ATS`)
};

const es_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade más palabras clave de habilidades — apunta a 8-15 para mejor coincidencia ATS`)
};

const it_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi più parole chiave sulle competenze — punta a 8-15 per un migliore matching ATS`)
};

const nl_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg meer vaardigheidstrefwoorden toe — streef naar 8-15 voor betere ATS-matching`)
};

const pl_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj więcej słów kluczowych umiejętności — celuj w 8-15 dla lepszego dopasowania ATS`)
};

const fi_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää enemmän osaamisavainsanoja — tavoittele 8-15 parempaa ATS-vastaavuutta varten`)
};

const da_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj flere søgeord for kompetencer — sigt efter 8-15 for bedre ATS-matching`)
};

const sv_ats_tip_more_skills = /** @type {(inputs: Ats_Tip_More_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till fler kompetensord — sikta på 8-15 för bättre ATS-matchning`)
};

/**
* | output |
* | --- |
* | "Add more skill keywords — aim for 8-15 for better ATS matching" |
*
* @param {Ats_Tip_More_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_more_skills = /** @type {((inputs?: Ats_Tip_More_SkillsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_More_SkillsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_more_skills(inputs)
	if (locale === "fr") return fr_ats_tip_more_skills(inputs)
	if (locale === "es") return es_ats_tip_more_skills(inputs)
	if (locale === "it") return it_ats_tip_more_skills(inputs)
	if (locale === "nl") return nl_ats_tip_more_skills(inputs)
	if (locale === "pl") return pl_ats_tip_more_skills(inputs)
	if (locale === "fi") return fi_ats_tip_more_skills(inputs)
	if (locale === "da") return da_ats_tip_more_skills(inputs)
	if (locale === "sv") return sv_ats_tip_more_skills(inputs)
	return en_ats_tip_more_skills(inputs)
});